import { ELEMENT_ATTRIBUTE_GROUP, ELEMENT_GROUPS } from '../utils';

const behaviourFields = [];

const contentFields = [
  {
    label: 'Placeholder Text',
    name: 'placeholder',
    editor: 'textbox',
    description:
      'The placeholder to display in the if there is no selected value',
    default: '',
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  },
  {
    label: 'Data Binding Source',
    name: 'datasourceId',
    description:
      'Choose a data source that this element will get its data from',
    editor: 'dropdown',
    function: {
      name: 'getDynamicDataSources',
      params: ['app.id']
    },
    default: '',
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  },
  {
    label: 'Data Binding Field',
    name: 'sourceField',
    editor: 'dropdown',
    description:
      'The field from the underlying datasource will be used as the value of this element',
    default: '',
    options: [],
    function: {
      name: 'getDynamicDataSourceFields',
      values: [],
      params: ['app.id', 'element.datasourceId']
    },
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  },
  {
    label: 'Modal Title',
    name: 'title',
    editor: 'textbox',
    description: 'The title of the modal',
    default: 'Choose an Item',
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  },
  {
    label: 'Source Type',
    name: 'source',
    editor: 'dropdown',
    description: 'The data source for the list',
    default: 'static',
    options: [
      {
        label: 'Static List of Items',
        value: 'static'
      },
      {
        label: 'List of Sub-Categories',
        value: 'subcategories'
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  },
  {
    label: 'Category',
    name: 'category',
    editor: 'dropdown',
    description: 'The category to filter the list by',
    default: '',
    options: [],
    valueKey: 'name',
    function: {
      name: 'getCategories',
      params: []
    },
    displayWhen: [
      {
        field: 'source',
        operator: '=',
        value: 'subcategories'
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  },
  {
    label: 'Labels',
    name: 'labels',
    editor: 'textbox',
    description: 'The labels of items that will appear in the list',
    default: ' ',
    displayWhen: [
      {
        field: 'source',
        operator: '=',
        value: 'static'
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  },
  {
    label: 'Values',
    name: 'values',
    editor: 'textbox',
    description: 'The values of items that will appear in the list',
    default: ' ',
    displayWhen: [
      {
        field: 'source',
        operator: '=',
        value: 'static'
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  }
];

const colorFields = [
  {
    name: 'backgroundColor',
    label: 'Background Color',
    description:
      'Background Color of the field in the screen (not in the modal)',
    editor: 'color',
    type: 'string',
    default: '#ffffff',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  },
  {
    name: 'borderColor',
    label: 'Border Color',
    description: 'Border Color of the field in the screen (not in the modal)',
    editor: 'color',
    type: 'string',
    default: '#718096',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  },
  {
    name: 'itemSeparatorColor',
    label: 'Item Separator Color',
    description: 'The color of the border between items',
    editor: 'color',
    type: 'string',
    default: '#e2e8f0',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  },
  'color',
  {
    name: 'itemBackgroundColor',
    label: 'Item Background Color',
    description: '',
    editor: 'color',
    type: 'string',
    default: '#ffffff',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  },
  {
    name: 'selectedItemBackgroundColor',
    label: 'Selected Item Background Color',
    description: '',
    editor: 'color',
    type: 'string',
    default: '#e2e8f0',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  },
  {
    name: 'selectedItemColor',
    label: 'Selected Item Text Color',
    description: '',
    editor: 'color',
    type: 'string',
    default: '#000000',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  },
  {
    label: 'Icon Color',
    name: 'iconColor',
    editor: 'color',
    description: 'The color of the icon',
    default: '#000000',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  }
];

const imageFields = [
  {
    name: 'iconMargin',
    label: 'Icon Margin',
    description: '',
    editor: 'boundary',
    type: 'string',
    default: '0 0 0 2',
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    name: 'icon',
    label: 'Icon',
    description: 'The icon that appears next to the dropdown',
    editor: 'icon',
    type: 'string',
    default: 'ArrowSmallDownIcon',
    group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
  },
  {
    name: 'iconsize',
    label: 'Icon Size',
    description: '',
    editor: 'iconsize',
    type: 'number',
    default: 8,
    group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
  }
];

const layoutFields = [
  'layout',
  'alignment',
  'margin',
  {
    label: 'Padding',
    name: 'padding',
    editor: 'boundary',
    description: 'The padding within the input',
    default: '15 5 15 15',
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'Item Padding',
    name: 'itemPadding',
    editor: 'boundary',
    description: 'The padding within a list item',
    default: '15 15 15 15',
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'Border Radius',
    name: 'borderRadius',
    editor: 'number',
    description:
      'The border radius of the field in the screen (not in the modal)',
    default: 4,
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'Border Width',
    name: 'borderWidth',
    editor: 'number',
    description:
      'The border width of the field in the screen (not in the modal)',
    default: 1,
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  }
];

const fontFields = [
  'fontFamily',
  {
    name: 'font',
    label: 'Font',
    description:
      'The font that appears in the screen for this element (not in the modal)',
    editor: 'fontsize',
    type: 'string',
    default: 20,
    group: ELEMENT_ATTRIBUTE_GROUP.FONTS
  },
  {
    name: 'itemFont',
    label: 'Item Font',
    description: 'The',
    editor: 'fontsize',
    type: 'string',
    default: 20,
    group: ELEMENT_ATTRIBUTE_GROUP.FONTS
  }
];

const FormModalListElementFields = {
  group: ELEMENT_GROUPS.FORMS,
  label: 'Form Modal List',
  icon: 'DocumentTextIcon',
  description:
    'An alternative to a drop down list, that displays the items to be selected in a popup modal.',
  properties: [
    ...behaviourFields,
    ...contentFields,
    ...layoutFields,
    ...fontFields,
    ...colorFields,
    ...imageFields
  ]
};

export default FormModalListElementFields;
